import { createSlice } from "@reduxjs/toolkit";

export interface LeadsManagementSlice {
  items: any[];
  selected: Record<string, boolean>;
}

const initialState: LeadsManagementSlice = {
  items: [],
  selected: {},
};

const leadsManagementSlice = createSlice({
  name: "leadsManagement",
  initialState,
  reducers: {
    setItems: (state, action) => {
      state.items = action.payload;
    },
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    clearSelected: (state) => {
      state.selected = {};
    },
  },
});

export const { setItems, setSelected, clearSelected } =
  leadsManagementSlice.actions;
export default leadsManagementSlice.reducer;
